<script>
  import { onMount } from 'svelte';

  export let tabs;
  export let onSelectTab;
  let grid;

  $: gridClasses = `grid grid-cols-${tabs.length} px-4 py-2`;
  $: activeClasses = `${gridClasses} bg-neutral-1100 absolute left-0 top-0 transition-clip-path ease-in-out duration-500`;

  const setActiveTabStyles = index => {
    let stepSize = 100 / tabs.length;

    let left = 100 - (stepSize * (index + 1));
    let right = 0 + (stepSize * index);

    grid.style.clipPath = `inset(0% ${left}% 0% ${right}% round 20px)`;
  }

  const selectTab = (index) => () => {
    setActiveTabStyles(index);
    onSelectTab(index);
  }

  onMount(() => setActiveTabStyles(tabs.findIndex(t => t.active) ?? 0));
</script>

<div class="w-fit px-2 py-1 border border-gray-400 rounded-full cursor-pointer">
  <div class="relative">
    <div class={gridClasses}>
      {#each tabs as tab, i (tab.title)}
        <div class="text-black text-base flex justify-center mx-6" on:click="{selectTab(i)}">
          {tab.title}
        </div>
      {/each}
    </div>

    <div class={activeClasses} bind:this={grid}>
      {#each tabs as tab (tab.title)}
        <div class="text-white text-base flex justify-center mx-6">
          {tab.title}
        </div>
      {/each}
    </div>
  </div>
</div>
